<template>
  <div class="combinatorSelectorWrapper">
    <label :for="column.id" class="label">{{ column.name }}</label>

    <template v-if="source">
      <template v-if="multiple">
        <div class="field">
          <div class="control">
            <input type="text" class="input" v-model="query" placeholder="Zoeken">
          </div>
        </div>

        <div class="selector field">
          <div class="control">
            <div class="select is-multiple">
              <select
                multiple size="20"
                v-model="values"
                @change="push">

                <option
                  v-for="option in myOptions"
                  :key="option.id"
                  :value="option.id"
                  :title="getColumnValue(option)"
                  :class="{ 'has-background-danger': !used.includes(option.id) }">
                  {{ getColumnValue(option) }}
                </option>
              </select>
            </div>
          </div>
        </div>
      </template>

      <template v-else>
        <select-wrapper
          :value="value"
          :options="myOptions"
          @input="update"
          placeholder="Selecteer een waarde"
        ></select-wrapper>
      </template>
    </template>
  </div>
</template>

<script>
import { bus } from '@/main'
import { strMixin } from '@/mixins/str'
import { mapGetters } from 'vuex'
import SelectWrapper from '@/components/wrappers/SelectWrapper'

export default {
  props: {
    column: {
      type: Object,
      required: true
    },
    options: {
      type: Array,
      required: true
    },
    multiple: {
      type: Boolean,
      default: false
    }
  },
  components: {
    SelectWrapper
  },
  mixins: [
    strMixin
  ],
  data () {
    return {
      query: '',
      values: [],
      value: null
    }
  },
  computed: {
    ...mapGetters({
      table: 'tables/table',
      source: 'dossiers/source',
      columns: 'columns/columns',
      datasets: 'datasets/datasets'
    }),
    columnId () {
      return this.column.id
    },
    myOptions () {
      if (this.multiple) {
        return this.options.filter(option => option.value.toLowerCase().includes(this.query.toLowerCase()))
      } else {
        const options = []

        // Disabled until we have a solution to handle duplicates and orphans created by this feature
        // const options = [{
        //   label: '--- Cel leegmaken ---',
        //   value: null
        // }]

        options.push(...this.options.map((option) => {
          return {
            label: option.value,
            value: option.id
          }
        }))

        return options
      }
    },
    index () {
      return this.columns.findIndex(x => x.column.id === this.columnId)
    },
    used () {
      return [...new Set(this.datasets.map(dataset => dataset.columns[this.index].value.id))]
    }
  },
  created () {
    bus.$on('clearValues', () => {
      this.values = []
      this.value = null
    })
  },
  methods: {
    push () {
      this.$emit('updateSelection', {
        columnId: this.columnId,
        values: this.values
      })
    },
    update (payload) {
      this.value = payload

      this.$emit('updateChanges', {
        columnId: this.columnId,
        value: this.value
      })
    },
    getColumnValue (value) {
      return (value.column_id === 34) ? `${value.value} (${this.getItemTitle(value)})` : value.value
    },
    getItemTitle (value) {
      const haystack = (value.kv_number) ? 'kennisenvaardigheden' : 'werkprocessen'

      if (this.source[haystack]) {
        const item = this.source[haystack].find(x => parseInt(x.nr) === value.number)

        return (item) ? `${item.hoofdstuk} | ${item.titel}` : ''
      }

      return null
    }
  }
}
</script>

<style scoped>
  label {
    height: 5rem;
  }

  .combinatorSelectorWrapper .selector:hover,
  .combinatorSelectorWrapper .input:focus {
    width: 1000px;
  }

  .select, select {
    width: 100%;
  }
</style>
